module.exports = __webpack_public_path__ + "img/banker-green-page_900.f4d01c8b.png";